import { render, staticRenderFns } from "./Organigrama.vue?vue&type=template&id=631bcc9f&scoped=true&"
import script from "./Organigrama.vue?vue&type=script&lang=ts&"
export * from "./Organigrama.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631bcc9f",
  null
  
)

export default component.exports